import urls from '../api_urls/deeplink'
import { _post } from '@/axios/request'
export function getModuleList (params) {
  return _post(urls.GET_MODULE_LIST, params)
}

export function getTableList (params) {
  return _post(urls.GET_TABLE_LIST, params)
}

export function deleteDeepLink (params) {
  return _post(urls.DELETE_DEEP_LINK, params)
}

export function save (params) {
  return _post(urls.SAVE, params)
}

// 增加扫描次数
export function incrScannedTimes (params) {
  return _post(urls.INCR_SCANNED_TIME, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/deeplink.js